<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش اشتراک ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/subscription/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت اشتراک جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="subscriptions.data"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.cover`]="{ item }">
                <v-img :src="item.cover" width="70" height="60" class="subscription-cover"></v-img>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/subscription/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="subscriptions.current_page"
                :length="subscriptions.last_page"
                circle
                @input="getSubscriptions()"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="560px" width="calc(100vw - 24px)">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این اشتراک اطمینان دارید؟
            در صورت پاک شدن کاربرانی که این اشتراک را خریده اند ، بدون اشتراک می شوند.
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="12" sm="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "SubscriptionIndexView",
  data() {
    return {
      loading: true,
      deleteDialog: false,
      selectedEntityId: null,
      subscriptions: {
        current_page: 1
      },
      headers: [
        {text: 'آیدی', value: 'id', align: 'center'},
        {text: 'عنوان', value: 'title', align: 'center'},
        {text: 'زیرنویس', value: 'subtitle', align: 'center'},
        {text: 'قیمت واقعی', value: 'price', align: 'center'},
        {text: 'قیمت نمایشی', value: 'show_price', align: 'center'},
        {text: 'زمان اشتراک(به روز)', value: 'duration', align: 'center'},
        {text: 'کاور', value: 'cover', align: 'center'},
        {text: 'اولویت', value: 'priority', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getSubscriptions()
  },
  methods: {
    getSubscriptions() {
      let url = 'order/subscription/index?page=' + this.subscriptions.current_page ?? 1
      window.axios.get(url).then((res) => {
        this.subscriptions = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(courseId) {
      this.selectedEntityId = courseId
      this.deleteDialog = true
    },
    finalDestroy() {
      window.axios.delete('order/subscription/delete/' + this.selectedEntityId).then(() => {
        this.getSubscriptions()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(()=>{
        this.deleteDialog = false
      })
    }

  }
}
</script>

<style scoped>
.subscription-cover {
  margin: 0 auto;
}

</style>
